/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { format } from "date-fns";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idUnidade: string;
  idSerie: string;
  tipoSerie: string | null;
  qtdParcelas: string | null;
  frequencia: string | null;
  valorParcela: string;
  dtVencimento: Date | string;
  juros: boolean;
  fixo: boolean;
  idLeadCorretor: any;
  idOportunidade?: any;
}

export function useEditarItem(props: Props) {
  function convertToNumber(brNumber: string): number {
    const numberWithoutDots = brNumber.replace(/\./g, "");
    const numberWithDot = numberWithoutDots.replace(",", ".");
    return parseFloat(numberWithDot);
  }

  function convertDate(date: Date | string): Date {
    if (typeof date === "string" && date.includes("T")) {
      return new Date(date);
    }
    return date as Date;
  }

  const parseValorParcela = (valor: string | number) => {
    if (typeof valor === "number") return valor;
    if (!valor) return 0;
    if (/^\d+(\.\d{1,2})?$/.test(valor)) return parseFloat(valor);
    const numberWithoutThousands = valor.replace(/\./g, "");
    const numberWithDot = numberWithoutThousands.replace(",", ".");
    return parseFloat(numberWithDot);
  };

  const postData = async () => {
    const INSERIR_ITEM = `${backofficeEnviroment}/common/oportunidades-lead/editar-serie/v1`;
    const { data } = await instance.put(INSERIR_ITEM, {
      idUnidade: props.idUnidade,
      idSerie: props?.idSerie,
      tipoSerie: Number(props.tipoSerie),
      frequencia: Number(props.frequencia),
      qtdParcelas: Number(props.qtdParcelas),
      valorParcela: parseValorParcela(props.valorParcela),
      dtVencimento: format(convertDate(props.dtVencimento), "yyyy-MM-dd"),
      juros: props.juros,
      fixo: props.fixo,
      idLeadCorretor: props.idLeadCorretor,
      idOportunidade: props.idOportunidade,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {},
    onError: (error: any) => {
      toast.error(
        `Erro ao editar item. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
